<template>
 <div>
   <div class="app-content content " v-show="!showUpdate">
     <div class="content-overlay"></div>
     <div class="header-navbar-shadow"></div>
     <div class="content-wrapper">
       <div class="content-header row">
         <div class="content-header-left col-md-9 col-12 mb-2">
           <Breadcrumb
               name="Payment Method"
               bc1="App"
               bc2="Payment Method"
               bc3="List"
           ></Breadcrumb>
         </div>
       </div>
       <div class="content-body">
         <div class="card">
           <div class="m-2">
             <div class="row">
               <div class="col-md-12 col-12">
                 <div class="d-flex align-items-center justify-content-end">
                   <button
                       type="button"
                       class="btn btn-primary"
                       @click="$router.push({ name: 'payment-add' })"
                   >
                     <AddButtonText name="Payment Method" />
                   </button>
                 </div>
               </div>
             </div>
           </div>

           <CommonTableStore
               :url="url"
               :tableHeaderValues="tableHeaderValues"
               :actions="actions"
               :deleteActions="deleteActions"
               :mutedData="mutedData"
               :storageKey="storageKey"
               :externalTotalRecord="externalTotalRecord"
               :show-per-page="true"
           />
         </div>
       </div>
     </div>
   </div>
   <UpdatePayment @back="showUpdate = false" v-if="showUpdate"  />
 </div>
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText, CommandIcon },
  created() {},
  mounted() {
    localStorage.setItem("url", "v1/get-payment-method");
    this.checkDataInStore('v1/get-payment-method')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-payment-method",
      storageKey: "paymentMethod",
      showUpdate:false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: function(value, row) {
            let html = `<p class="text-primary mb-25" >${value}</p>`
            if (row.independent_settlement == 1) {

              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary" >Independent Settlement</div>
                    </div>
                </div>
                `
            }

            return html;
          }
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == true) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }

            if (row.is_default == 1) {
              html += '<span class="badge badge-secondary ml-1">Default</span>';
            }

            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {

            let data = {
              ...row,
              index: index,
              row: row,
              key: "paymentMethodUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "paymentMethodDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-payment-method", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("paymentMethod");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "paymentMethod";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
